"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "currentColor",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "globe",
    transform: "translate(2.000000, 2.000000)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      id: "Oval",
      cx: "10",
      cy: "10",
      r: "10"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,10 L20,10",
      id: "Path"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,2.22044605e-16 C12.5012804,2.73835289 13.9227528,6.29203385 14,10 C13.9227528,13.7079661 12.5012804,17.2616471 10,20 C7.49871962,17.2616471 6.07724724,13.7079661 6,10 C6.07724724,6.29203385 7.49871962,2.73835289 10,0 Z",
      id: "Path"
    })]
  })
}));